import { render, staticRenderFns } from "./BoardSettingPopup.vue?vue&type=template&id=8dafee1c&scoped=true"
import script from "./BoardSettingPopup.vue?vue&type=script&lang=ts"
export * from "./BoardSettingPopup.vue?vue&type=script&lang=ts"
import style0 from "./BoardSettingPopup.vue?vue&type=style&index=0&id=8dafee1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dafee1c",
  null
  
)

export default component.exports